import { render } from "./SearchInterface.vue?vue&type=template&id=00d3f2a4"
import script from "./SearchInterface.vue?vue&type=script&lang=ts"
export * from "./SearchInterface.vue?vue&type=script&lang=ts"

import "./SearchInterface.vue?vue&type=style&index=0&id=00d3f2a4&lang=scss"
script.render = render

export default script